var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagEnglish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3125 3.75H4.6875C2.61643 3.75 0.9375 5.42893 0.9375 7.5V22.5C0.9375 24.5711 2.61643 26.25 4.6875 26.25H25.3125C27.3836 26.25 29.0625 24.5711 29.0625 22.5V7.5C29.0625 5.42893 27.3836 3.75 25.3125 3.75Z",
    fill: "#071B65"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78236 3.75H4.68768C2.83049 3.75 1.29861 5.10375 1.00049 6.87563L25.218 26.25H25.3127C27.1699 26.25 28.7017 24.8962 28.9999 23.1244L4.78236 3.75Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8594 17.8125H18.5156L27.8287 25.2628C28.1916 24.9319 28.4888 24.5344 28.6997 24.0844L20.8594 17.8125Z",
    fill: "#B92932"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.30029 5.91468L9.14061 12.1875H11.4844L2.17123 4.73718C1.80842 5.06812 1.51123 5.46468 1.30029 5.91468Z",
    fill: "#B92932"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.68768 26.25H4.78236L28.9999 6.87563C28.7017 5.10281 27.1699 3.75 25.3127 3.75H25.218L1.00049 23.1244C1.29861 24.8972 2.83049 26.25 4.68768 26.25Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8125 3.75H12.1875V26.25H17.8125V3.75Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0625 12.1875H0.9375V17.8125H29.0625V12.1875Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 3.75H13.125V26.25H16.875V3.75Z",
    fill: "#B92932"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0625 16.875V13.125L0.9375 13.125V16.875H29.0625Z",
    fill: "#B92932"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4581 3.94687L17.8125 10.8619V12.1875H18.5156L27.8372 4.74374C27.4444 4.38374 26.9766 4.11468 26.4581 3.94687Z",
    fill: "#B92932"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.18262 25.2722C2.57074 25.6228 3.03012 25.8872 3.53918 26.0522L12.1876 19.1334V17.8134H11.4845L2.18262 25.2722Z",
    fill: "#B92932"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M25.3125 3.75H4.6875C2.61656 3.75 0.9375 5.42906 0.9375 7.5V22.5C0.9375 24.5709 2.61656 26.25 4.6875 26.25H25.3125C27.3834 26.25 29.0625 24.5709 29.0625 22.5V7.5C29.0625 5.42906 27.3834 3.75 25.3125 3.75ZM28.125 22.5C28.125 24.0506 26.8631 25.3125 25.3125 25.3125H4.6875C3.13687 25.3125 1.875 24.0506 1.875 22.5V7.5C1.875 5.94937 3.13687 4.6875 4.6875 4.6875H25.3125C26.8631 4.6875 28.125 5.94937 28.125 7.5V22.5Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.3125 4.6875H4.6875C3.13406 4.6875 1.875 5.94656 1.875 7.5V8.4375C1.875 6.88406 3.13406 5.625 4.6875 5.625H25.3125C26.8659 5.625 28.125 6.88406 28.125 8.4375V7.5C28.125 5.94656 26.8659 4.6875 25.3125 4.6875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagEnglish);
export default __webpack_public_path__ + "static/media/flag_english.82f5960bd2a6ef7f914660a2fd453999.svg";
export { ForwardRef as ReactComponent };